import StructureCommercial from './StructureCommercial';
export default StructureCommercial;
